// extracted by mini-css-extract-plugin
export default {"wrapper_editableDiv":"style_wrapper_editableDiv__g7NXY","editableDiv":"style_editableDiv__FJfKY","placeholder":"style_placeholder__RPtlp","tagHyperLink":"style_tagHyperLink__exUoG"};